module.exports = __webpack_public_path__ + "img/jyz0glxt.3df2f45e.png";